export default "__VITE_ASSET__3f8effc8__"